import { CSSProperties, useMemo } from "react";

import { FieldSizeType } from "@/components/@types";
import {
  FieldEnum,
  type FieldEnumVariant,
} from "@/components/organisms/Field/FieldEnum";
import { EnumColors } from "@/constants/values";

export function SimpleEnum({
  label,
  enumColor,
  size,
  style,
  variant = "soft",
  endDecorator,
}: {
  label: string | React.ReactNode;
  enumColor: (typeof EnumColors)[keyof typeof EnumColors];
  size?: FieldSizeType;
  style?: CSSProperties;
  /** Soft, tinted in its colour; or outlined, its colour a dot before its word. */
  variant?: FieldEnumVariant;
  /** After its word, inside the chip: a key that does something to it. */
  endDecorator?: React.ReactNode;
}) {
  const valueOptions = useMemo(() => {
    return {
      enum: [
        {
          key: String(label),
          value: String(label),
        },
      ],
      getColors: (mode: string | undefined) => {
        const resolved = mode === "dark" ? "dark" : "light";
        return {
          [String(label)]: enumColor[resolved],
        };
      },
    };
  }, [label, enumColor]);

  return (
    <FieldEnum
      readOnly
      value={label}
      valueOptions={valueOptions}
      isMultiline={false}
      size={size}
      variant={variant}
      endDecorator={endDecorator}
      style={{ paddingLeft: 0, paddingRight: 0, ...style }}
    />
  );
}
